import { useEffect, useRef, useState } from "react";
import { APP_VERSION } from "@/appVersion";
import faviconUrl from "@/favicon.svg";
import { DraggablePanel } from "./right-panel/DraggablePanel";

const ABOUT_PANEL_WIDTH = 288;

export function AboutDialog({ onClose }: { onClose: () => void }) {
  const panelRef = useRef<HTMLDivElement>(null);
  const [initialOffset] = useState(() => ({
    right: Math.max(24, (window.innerWidth - ABOUT_PANEL_WIDTH) / 2),
    top: Math.max(48, window.innerHeight * 0.28),
  }));

  useEffect(() => {
    function handlePointerDown(event: PointerEvent): void {
      const target = event.target;
      if (!(target instanceof Node) || panelRef.current?.contains(target)) {
        return;
      }
      onClose();
    }

    function handleKeyDown(event: KeyboardEvent): void {
      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
      }
    }

    window.addEventListener("pointerdown", handlePointerDown);
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("pointerdown", handlePointerDown);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  return (
    <DraggablePanel
      panelRef={panelRef}
      storageKey="about"
      title="About"
      widthClass="w-72"
      initialOffset={initialOffset}
      onClose={onClose}
    >
      <div className="flex flex-col items-center gap-2 text-center">
        <img src={faviconUrl} alt="" className="size-12" draggable={false} />
        <div className="space-y-1">
          <div className="text-[14px] font-medium text-slate-100">Curva</div>
          <p className="text-[12px] leading-5 text-slate-400">
            Version {APP_VERSION}
          </p>
        </div>
      </div>
    </DraggablePanel>
  );
}
